import type { GetStaticPropsContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useStagingMode } from "@middleware/hooks";
import { Container } from "@components/ui";
import { MainLayout } from "@layouts/MainLayout/MainLayout";
import { Content } from "@prismicio/client";
import { FaqContent } from "@components/pages/faq/FaqContent";
import { createClient } from "../../prismicio";

type PageProps = {
  pageProd: Content.PageFaqDocument;
  pageStaging: Content.PageFaqStagingDocument;
  homepageProd: Content.HomepageDocument;
  homepageStaging: Content.HomepageStagingDocument;
};

export async function getStaticProps({
  locale,
  previewData,
}: GetStaticPropsContext) {
  const client = createClient({ previewData });

  const [pageProd, pageStaging] = await Promise.all([
    client.getSingle("page_faq"),
    client.getSingle("page_faq_staging"),
  ]);

  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "common",
        "header",
        "footer",
      ])),
      pageProd,
      pageStaging,
    },
  };
}

const FAQPage = ({ pageProd, pageStaging }: PageProps) => {
  const { isStagingMode } = useStagingMode();

  if (isStagingMode) {
    return (
      <Container className="page-cms">
        <FaqContent page={pageStaging} />
      </Container>
    );
  }

  return (
    <Container className="page-cms">
      <FaqContent page={pageProd} />
    </Container>
  );
};

FAQPage.layout = MainLayout;
export default FAQPage;
